<template>
  <el-form
    ref="form"
    class="sui-form"
    :class="`sui-form--${elMode}`"
    :model="model"
    :inline="inline"
    :size="size"
    :disabled="disabled"
    :label-position="labelPosition"
    :label-suffix="labelSuffix"
    :hide-required-asterisk="hideRequiredAsterisk"
    :show-message="showMessage"
    :inline-message="inlineMessage"
    :status-icon="statusIcon"
    :rules="rules"
    :validate-on-rule-change="validateOnRuleChange"
    @validate="(prop, flag, msg) => $emit('validate', prop, flag, msg)"
    @submit.native.prevent
  >
    <slot>
      <template v-if="_fieldArr">
        <sui-prop v-for="(field, i) in _fieldArr" :key="i" :tag="field.tag" :prop="field">
          <template v-if="colNum < 1">
            <template v-for="(item, idx) in field.items">
              <!-- inline为true时 强制换行 -->
              <br v-if="inline && item.wrap" :key="idx + 'br1'" /><sui-prop
                :key="idx"
                tag="sui-form-item"
                :prop="item"
                :ref="item.ref"
                tag-ref="formItem"
              >
                <div v-if="$scopedSlots[item.prop + '_text'] || $scopedSlots[item.prop + '_label']" :slot="item.prop + '_label'">
                  <slot v-if="$scopedSlots[item.prop + '_text']" :name="item.prop + '_text'"></slot>
                  <slot v-else :name="item.prop + '_label'"></slot>
                </div>
                <slot v-if="$scopedSlots[item.prop]" :name="item.prop"></slot>
              </sui-prop>
            </template>
            <template v-if="btns && _lastShowFieldIdx === i">
              <el-form-item v-if="btnsInline" :key="i + '_inline_btns'">
                <sui-button-group :btns="btns"></sui-button-group>
              </el-form-item>
              <div v-else :class="['form-btns', btnsAlign ? 'btns-' + btnsAlign : '']" :key="i + '_btns'">
                <sui-button-group :btns="btns"></sui-button-group>
              </div>
            </template>
          </template>
          <template v-else>
            <template v-for="(item, idx) in field.items">
              <el-row :key="idx" :prop="rowAttr">
                <el-col v-for="(_item, _i) in item" :key="_i" :span="_item.span" :offset="_item.offset">
                  <sui-prop :key="_i" tag="sui-form-item" :prop="_item" :ref="item.ref" tag-ref="formItem">
                    <div v-if="$scopedSlots[_item.prop + '_text'] || $scopedSlots[_item.prop + '_label']" :slot="_item.prop + '_label'">
                      <slot v-if="$scopedSlots[_item.prop + '_text']" :name="_item.prop + '_text'"></slot>
                      <slot v-else :name="_item.prop + '_label'"></slot>
                    </div>
                    <slot v-if="$scopedSlots[_item.prop]" :name="_item.prop"></slot>
                  </sui-prop>
                </el-col>
              </el-row>
            </template>
          </template>
        </sui-prop>
      </template>
      <template v-else-if="items">
        <template v-if="colNum < 1">
          <template v-for="(item, idx) in _items">
            <!-- inline为true时 强制换行 -->
            <br v-if="inline && item.wrap" :key="idx + 'br2'" /><sui-prop
              :key="item.prop"
              tag="sui-form-item"
              :prop="item"
              :ref="item.ref"
              tag-ref="formItem"
            >
              <div v-if="$scopedSlots[item.prop + '_text'] || $scopedSlots[item.prop + '_label']" :slot="item.prop + '_label'">
                <slot v-if="$scopedSlots[item.prop + '_text']" :name="item.prop + '_text'"></slot>
                <slot v-else :name="item.prop + '_label'"></slot>
              </div>
              <slot v-if="$scopedSlots[item.prop]" :name="item.prop"></slot>
            </sui-prop>
          </template>
        </template>
        <template v-else>
          <template v-for="(item, idx) in _items">
            <el-row :key="_items.prop" :prop="rowAttr">
              <el-col v-for="(_item, _idx) in item" :key="_item.prop" :span="_item.span" :offset="_item.offset">
                <sui-prop tag="sui-form-item" :prop="_item" :ref="_item.ref" tag-ref="formItem">
                  <div v-if="$scopedSlots[_item.prop + '_text'] || $scopedSlots[_item.prop + '_label']" :slot="_item.prop + '_label'">
                    <slot v-if="$scopedSlots[_item.prop + '_text']" :name="_item.prop + '_text'"></slot>
                    <slot v-else :name="_item.prop + '_label'"></slot>
                  </div>
                  <slot v-if="$scopedSlots[_item.prop]" :name="_item.prop"></slot>
                </sui-prop>
              </el-col>
            </el-row>
          </template>
        </template>
      </template>
    </slot>
    <template v-if="btns && _lastShowFieldIdx < 0">
      <el-form-item v-if="btnsInline">
        <sui-button-group :btns="btns"></sui-button-group>
      </el-form-item>
      <div v-else :class="['form-btns', btnsAlign ? 'btns-' + btnsAlign : '']">
        <sui-button-group :btns="btns"></sui-button-group>
      </div>
    </template>
  </el-form>
</template>
<script>
import { filter } from 'lodash-es'
import { indexOf } from '../../utils/utils'
export default {
  name: 'SuiForm',
  provide() {
    return {
      SuiForm: this
    }
  },
  props: {
    model: {
      type: Object,
      default: () => {
        return {}
      }
    },
    rules: {
      type: Object,
      default: () => ({})
    },
    inline: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      validator: function (value) {
        return ['medium', 'small', 'mini'].indexOf(value) !== -1
      }
    },
    disabled: {
      type: [Boolean, Array]
    },
    labelWidth: {
      type: [String, Number],
      default: 85
    },
    itemWidth: {
      type: [String, Number],
      default: null
    },
    inputWidth: {
      type: [String, Number],
      default: null
    },
    labelPosition: {
      type: String,
      default: 'right',
      validator: function (value) {
        return ['left', 'right', 'top'].indexOf(value) !== -1
      }
    },
    labelSuffix: {
      type: String,
      default: ''
    },
    hideRequiredAsterisk: {
      type: Boolean
    },
    showMessage: {
      type: Boolean,
      default: true
    },
    inlineMessage: {
      type: Boolean
    },
    statusIcon: {
      type: Boolean
    },
    validateOnRuleChange: {
      type: Boolean,
      default: true
    },
    items: {
      type: Array,
      default: null
    },
    btnsInline: {
      type: Boolean
    },
    btnsAlign: {
      type: String,
      default: 'right',
      validator: function (value) {
        return ['left', 'right', 'center'].indexOf(value) !== -1
      }
    },
    btns: {
      type: Array,
      default: null
    },
    fieldArr: {
      type: Array,
      default: null
    },
    fieldTagPrefix: {
      type: Array,
      default: () => ['sui-', 'el-']
    },
    placeholderVisible: {
      type: Boolean,
      default: true
    },
    // 是否是可折叠块
    isField: {
      type: Boolean,
      default: true
    },
    // 栅格每行数量
    colNum: {
      type: Number,
      default: -1
    },
    // 栅格左右偏移
    sideOffset: {
      type: Number,
      default: 0
    },
    // 栅格右偏移
    sideRightOffset: {
      type: Number,
      default: -1
    },
    // 栅格内部偏移
    colOffset: {
      type: Number,
      default: 0
    },
    // 栅格el-row属性
    rowAttr: {
      type: Object,
      default: null
    }
  },
  data() {
    return {}
  },
  computed: {
    elMode() {
      return (this.$ELEMENT || {}).$mode || 'easy'
    },
    _colNum() {
      return Math.floor((24 - (this.sideOffset + this._sideRightOffset) - (this.colNum - 1) * this.colOffset) / this.colNum)
    },
    _sideRightOffset() {
      return this.sideRightOffset >= 0 ? this.sideRightOffset : this.sideOffset
    },
    _items() {
      if (this.colNum > 0 && this.items.length > 0) {
        return this.initRow(this.items)
      }
      return this.items
    },
    _fieldArr() {
      if (Array.isArray(this.fieldArr) && this.fieldArr.length > 0) {
        const _fieldArr = []
        this.fieldArr.forEach((field) => {
          let fieldTag = field.tag || 'field'
          let pre = this.fieldTagPrefix.find((p) => fieldTag.startsWith(p))
          fieldTag = pre ? fieldTag : 'sui-' + fieldTag

          const _field = { ...field, tag: fieldTag }
          const _items = filter(this.items, (item) => {
            return indexOf(_field.propArr, item.prop) !== -1
          })
          delete _field.propArr
          if (_field.tag.endsWith('field')) {
            // 更新field配置
            _field.value = field.value !== undefined ? field.value : true
            _field.closable = field.closable !== undefined ? field.closable : true
          }

          // 兼容栅格布局
          if (this.colNum > 0) {
            _field.items = this.initRow(_items)
          } else {
            _field.items = _items
          }

          // 是否显示field
          _field.visible = _field.items.length > 0 && _field.items.some(it => it.visible)

          // 添加到列表中
          _fieldArr.push(_field)
        })
        return _fieldArr
      }
      return this.fieldArr
    },
    _lastShowFieldIdx() {
      if (this.fieldArr && this.fieldArr.length > 0 && this.fieldArr.some(it => it.tag === 'form-group')) {
        return this._fieldArr.findLastIndex(it => it.visible)
      }
      return -1
    }
  },
  created() {
    // 列项处理，补充完善item的值，用于后面隐藏禁用等方法。
    if (Array.isArray(this.items)) {
      this.items.forEach((item, i) => {
        if (item.visible === undefined) {
          this.$set(this.items[i], 'visible', true)
        }
        if (item.required === undefined) {
          this.$set(this.items[i], 'required', false)
        }
        if (item.disabled === undefined) {
          this.$set(this.items[i], 'disabled', false)
        }
        if (item['is-test'] === undefined) {
          this.$set(this.items[i], 'is-test', this.$attrs['is-test'] || false)
        }
        if (this.$attrs['test-id'] !== null && item['test-id'] === undefined) {
          this.$set(this.items[i], 'test-id', this.$attrs['test-id'])
        }
        if (this.$attrs['allow-test-components'] !== null && item['allow-test-components'] === undefined) {
          this.$set(this.items[i], 'allow-test-components', this.$attrs['allow-test-components'])
        }
        if (this.$attrs['test-suffix'] !== null && item['test-suffix'] === undefined) {
          this.$set(this.items[i], 'test-suffix', this.$attrs['test-suffix'])
        }
      })
    }
    // 设置placeholder是否可见
    if (this.placeholderVisible === false) {
      this.items.forEach((item) => {
        this.$set(item, 'placeholder', '')
      })
    }
  },
  methods: {
    getColNum(width) {
      return Math.ceil((width / this.formWidth) * 24)
    },
    // 获取对应栅格信息
    initRow(items) {
      let _rowItems = []
      const _allItems = []
      let num = this.sideOffset + this._sideRightOffset
      let _index = 0
      items.forEach((item, index) => {
        // 隐藏元素不加载处理
        if (item.visible === false || item.editFlag === '4') {
          if (index === items.length - 1) {
            _allItems.push(_rowItems)
          }
          return true
        }
        const _item = { ...item }
        let _colNum = this._colNum
        if (this.colNum === 0) {
          const _width = item.itemWidth || this.itemWidth
          // console.log("form:"+_width);
          _colNum = this.getColNum(_width)
        }
        const _span = _colNum * (item.colspan || 1) + ((item.colspan || 1) - 1) * this.colOffset
        num += _index === 0 ? _span : _span + this.colOffset
        if (num > 24 || (_index === this.colNum && _index > 0)) {
          _allItems.push(_rowItems)
          _rowItems = []
          _index = 0
          num = this.sideOffset + this._sideRightOffset + _span
        }
        _item.offset = _index === 0 ? this.sideOffset : this.colOffset
        _index += item.colspan || 1
        _item.span = _span > 24 - (this.sideOffset + this._sideRightOffset) ? 24 - (this.sideOffset + this._sideRightOffset) : _span
        delete _item.colspan
        _rowItems.push(_item)
        if (index === items.length - 1) {
          _allItems.push(_rowItems)
        }
      })
      return _allItems
    },
    // 清空输入项
    clearFields(fields) {
      let keys = this.getFields(fields)
      keys.forEach((key) => {
        if (Array.isArray(this.model[key])) {
          this.model[key] = []
        } else if (typeof this.model[key] === 'boolean') {
          this.model[key] = null
        } else if (typeof this.model[key] === 'string') {
          this.model[key] = ''
        } else {
          this.model[key] = null
        }
      })
    },
    // 必填字段修改 不传时代表全部必传
    requiredFields(fields) {
      let keys = this.getFields(fields)
      this.items.forEach((item) => {
        if (indexOf(keys, item.prop) !== -1) {
          item.required = true
        } else {
          item.required = false
        }
      })
    },
    // 禁用 某些字段
    disabledFields(fields) {
      let keys = this.getFields(fields)
      this.items.forEach((item) => {
        if (indexOf(keys, item.prop) !== -1) {
          item.disabled = true
        }
      })
    },
    // 启用 某些字段
    enabledFields(fields) {
      let keys = this.getFields(fields)
      this.items.forEach((item) => {
        if (indexOf(keys, item.prop) !== -1) {
          item.disabled = false
        }
      })
    },
    // 隐藏
    hideFields(fields) {
      let keys = this.getFields(fields)
      this.items.forEach((item) => {
        if (indexOf(keys, item.prop) !== -1) {
          item.visible = false
        }
      })
    },
    // 显示
    showFields(fields) {
      let keys = this.getFields(fields)
      this.items.forEach((item) => {
        if (indexOf(keys, item.prop) !== -1) {
          item.visible = true
        }
      })
    },
    getFields(fields) {
      if (!fields) {
        return Object.keys(this.model)
      } else {
        return Array.isArray(fields) ? fields : fields.split(',')
      }
    },
    // form表单的校验方法，okCallback：成功回调，errorCallback：失败回调
    valid(okCallback, errorCallback) {
      return this.$refs.form.validate((flag, object) => {
        if (flag) {
          typeof okCallback === 'function' && okCallback(this.model)
        } else {
          typeof errorCallback === 'function' && errorCallback(this.model, object)
        }
      })
    },
    // form原生方法
    validate(callback) {
      return this.$refs.form.validate(callback)
    },
    validateField(fields, callback) {
      return this.$refs.form.validateField(fields, callback)
    },
    resetFields() {
      this.$refs.form.resetFields()
    },
    clearValidate(fields) {
      if (fields) {
        this.$refs.form.clearValidate(fields)
      } else {
        this.$refs.form.clearValidate()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.sui-form ::v-deep {
  &.el-form--inline {
    margin-top: -9px;
    margin-bottom: -9px;
    .el-form-item {
      margin-bottom: 9px;
      margin-top: 9px;
    }
  }
  .form-btns {
    margin-top: 18px;
    &.btns-left {
      text-align: left;
    }
    &.btns-right {
      text-align: right;
    }
    &.btns-center {
      text-align: center;
    }
  }
  &.el-form--inline {
    .form-btns {
      margin-top: 9px;
    }
  }
  .el-form-item .label_item {
    display: inline-block;
  }
  > .el-row .el-col {
    & > .el-form-item {
      width: 100% !important;
      display: flex !important;

      > .el-form-item__content {
        flex: 1;
        & > div {
          width: 100% !important;
        }
      }
    }

    .el-form-item__content,
    .sui-bond .sui-input,
    .sui-number-plus .sui-input .el-form-item__content > div {
      width: 100% !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SimbartUI/components/data/SuiForm.vue